import * as React from 'react'
import BottomNavLogoutButton from './Logout'
import BottomNavAdminSection from './AdminSection'


export default function BottomNavSections() {

    return <div className="navTools">
        <BottomNavAdminSection />
        <BottomNavLogoutButton />
    </div>
}